import { ListComplaints } from "./list-complaints";

export default ListComplaints;
